import { render, staticRenderFns } from "./promotion-edit.vue?vue&type=template&id=c4f84f6c"
import script from "./promotion-edit.vue?vue&type=script&lang=js"
export * from "./promotion-edit.vue?vue&type=script&lang=js"
import style0 from "./promotion-edit.vue?vue&type=style&index=0&id=c4f84f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports